import React from 'react';
import styled from 'styled-components';
import { IWeightReportState } from '../../../data/providers/reports/weightReportProvider';
import { Entity } from '../../../data/types';
import { Column } from '../../layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { GraphContainer } from '../../shared/graphs/GraphContainer';
import { Notable } from '../../shared/pdf/Notable';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { WeightGraph } from './WeightGraph';

interface IProps {
  reportState: IWeightReportState;
  pdfMode?: EPdfMode;
  quartileColors: string[];
  entity: Entity;
}

export const WeightGraphCard = (props: IProps): React.ReactElement => {
  return (
    <PdfCardWrapper className='avoid-break' pdf={isPdf(props.pdfMode)}>
      <Notable pdf={isPdf(props.pdfMode)}>
        <Card inverse={shouldInvert(props.pdfMode)} noTopRadius>
          <Column>
            <CardBody withoutFooter>
              <GraphContainer inverse={shouldInvert(props.pdfMode)}>
                <WeightGraph sessions={props.reportState.sessionMeans} />
              </GraphContainer>
            </CardBody>
          </Column>
        </Card>
      </Notable>
    </PdfCardWrapper>
  );
};

const PdfCardWrapper = styled.div<{ pdf?: boolean }>`
  flex: 1;
`;
